import React, { createContext } from 'react';

export const deliveryChannels = ['wsp', 'sms', 'email'] as const;

export type DeliveryChannel = (typeof deliveryChannels)[number];

export interface IMessageTemplate {
  _id: string;
  scope: 'company' | 'inspection_template';
  companyId: string;
  userId: string;
  status: 'active' | 'inactive';
  gatewayId?: string;
  gatewayStatus?: 'approved' | 'rejected' | 'pending';
  channel: DeliveryChannel;
  template: {
    footer?: string | null | undefined;
    subject: string;
    body: string;
  };
}

export interface IMessageTemplateContext {
  multiple?: boolean;
  logo?: string;
  deadlineDays?: number;
  channels: (typeof deliveryChannels)[number][];
  postMethod: (
    input: Pick<IMessageTemplate, 'template' | 'channel'>
  ) => Promise<any>;
  updateMethod: (
    messageTemplateId: string,
    update: IMessageTemplate['template']
  ) => Promise<any>;
  updateStatusMethod: (
    messageTemplateId: string,
    status: IMessageTemplate['status']
  ) => Promise<any>;
}

export const MessageTemplateCtx = createContext<IMessageTemplateContext>(
  {} as any
);

export const MessageTemplateProvider: React.FC<
  React.PropsWithChildren<IMessageTemplateContext>
> = ({ children, ...rest }) => {
  return (
    <MessageTemplateCtx.Provider value={rest}>
      {children}
    </MessageTemplateCtx.Provider>
  );
};
